import { splashScene } from './scenes/splash.js';
import { menuScene } from './scenes/menu.js';
import { packsScene } from './scenes/packs.js';
import { gameScene } from './scenes/game.js';
import { resultScene } from './scenes/result.js';
import { request } from './api/client.js';
import { applyConfig } from './game/tuning.js';

const SCENES = {
  splash: splashScene,
  menu: menuScene,
  packs: packsScene,
  game: gameScene,
  result: resultScene
};

const root = document.getElementById('app');
const state = {
  user: null,
  pack: null,
  result: null
};

let currentScene = null;

async function goto(name) {
  if (currentScene?.destroy) {
    try { await currentScene.destroy(); } catch {}
  }
  const scene = SCENES[name];
  if (!scene) throw new Error(`Unknown scene: ${name}`);
  root.innerHTML = '';
  currentScene = scene;
  await scene.mount(root, { state, goto });
}

window.addEventListener('error', (e) => {
  console.error('window error', e.error);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('unhandled rejection', e.reason);
});

// Fire-and-forget: fetch live game tuning so admin config edits take effect.
// Defaults in tuning.js keep the game working if BE is unreachable.
request('GET', '/v1/config')
  .then((cfg) => applyConfig(cfg))
  .catch((e) => console.warn('config fetch failed (using defaults)', e?.message || e));

goto('splash');
